import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { MembersDashboardTabs } from "./summary/members-tabs";
import { MembersDataTable } from "./details/members-data-table";
import { MembersChartSection } from "./details/members-chart-section";
import { MembersDashboardHeaderSection } from "./members-header-section";
import { MembersDashboardSummary } from "./summary/members-dashboard-summary";

dayjs.locale("ko");

const Section = styled.section`
  position: relative;
  padding: 0 16px 24px;
  margin: 0 auto;
`;

const Article = styled.article`
  background: #fff;
  padding: 16px 0 24px;
  border-radius: 16px;
  overflow: hidden;
`;

export function MembersDashboard() {
  return (
    <Section>
      <MembersDashboardHeaderSection />
      <Article>
        <MembersDashboardTabs />
        <MembersDashboardSummary />
        <MembersChartSection />
        <MembersDataTable />
      </Article>
    </Section>
  );
}
